export function decomposeColor(hex: number): { r: number, g: number, b: number }
{
  return {
    r: (hex >> 16) & 0xff,
    g: (hex >> 8) & 0xff,
    b: hex & 0xff,
  };
}

export function composeColor(r: number, g: number, b: number): number
{
  return Math.floor(r << 16) | Math.floor(g << 8) | Math.floor(b);
}